/**
 * @typedef {object} SESSION_TIMEOUT
 * @description SESSION_TIMEOUT constant values
 * @prop {number} UPDATE_DELAY Controls the delay between the new countdown on modal
 * @prop {number} TIMER Controls the countdown on TimeOut Modal
 * @prop {number} GMA_TIMEOUT GMA default timeout value
 */
export const SESSION_TIMEOUT = {
  UPDATE_DELAY: 1000, // Value in milliseconds, 1000 corresponds to 1 second
  TIMER: 60 * 5, // Value in seconds, 300 corresponds to 5 minutes
  GMA_TIMEOUT: 1200 //  Value in seconds, 1200 corresponds to 20 minutes
};